import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import CMSGallery from '../components/CMSGallery'

export default function ExpressDelivery() {
  return (
    <div className="space-y-0">
      <SEO
        title="Ekspreslevering 24/7 & Akut Transport | Transport4U"
        description="Ekspres godstransport med afgang inden for 2 timer. Dag-til-dag og dag-til-i-dag kørsel døgnet rundt, alle dage inklusive weekender og helligdage. Tlf. 50 35 20 35."
      />

      {/* Hero */}
      <section className="bg-navy-950 text-white py-16 lg:py-24 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-sky-950 border border-sky-500/40 text-sky-300 text-xs font-bold uppercase tracking-wider">
              <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
              <span>Døgnåben Logistik</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white tracking-tight">
              Fleksibel bestilling og ekspreslevering 24/7
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed">
              Ved akutte transportbehov rykker Transport4U hurtigt ud med mulighed for afgang på ruten inden for blot 2 timer. Vi modtager ordrer døgnet rundt – også i weekender og på helligdage.
            </p>
          </div>
        </div>
      </section>

      {/* Urgent Callout Banner */}
      <section className="bg-sky-600 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4 text-center md:text-left">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/15 text-white">
              <i className="fa-solid fa-bolt-lightning text-2xl" aria-hidden="true" />
            </div>
            <div>
              <h2 className="text-xl font-bold">Har du en akut forsendelse lige nu?</h2>
              <p className="text-sky-100 text-xs sm:text-sm">
                Vores chauffører er parate til at køre inden for 2 timer.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-white text-slate-950 font-extrabold text-sm hover:bg-sky-50 transition-colors shadow-md whitespace-nowrap"
            >
              <span>Bestil ekspres online</span>
              <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
            </Link>
            <a
              href="tel:+4550352035"
              className="inline-flex items-center gap-2 px-5 py-3.5 rounded-xl bg-slate-950 text-white font-bold text-sm hover:bg-slate-900 transition-colors shadow-md whitespace-nowrap"
            >
              <i className="fa-solid fa-phone text-sky-400" aria-hidden="true" />
              <span className="whitespace-nowrap">Tlf: 50 35 20 35</span>
            </a>
          </div>
        </div>
      </section>

      {/* Main Express Features */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Box 1 */}
            <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200/80 space-y-4">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-sky-100 text-sky-700">
                <i className="fa-solid fa-calendar-check text-xl" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-bold text-slate-900">
                Modtagelse af ordrer 24/7
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Transport4U står klar døgnet rundt, alle 365 dage om året. Vi udfører transporter i weekender og på helligdage uden forsinkelser.
              </p>
              <ul className="text-xs text-slate-700 space-y-2 pt-2 border-t border-slate-200/60 font-medium">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                  <span>Døgnåben telefonisk betjening</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                  <span>Kørsel i weekender & helligdage</span>
                </li>
              </ul>
            </div>

            {/* Box 2 */}
            <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200/80 space-y-4">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-sky-100 text-sky-700">
                <i className="fa-solid fa-truck-fast text-xl" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-bold text-slate-900">
                Dag-til-dag og Dag-til-i-dag
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Vi sikrer hurtig fremførsel. Ved dag-til-i-dag henvendelser afhenter og leverer vi godset samme dag for maksimal fleksibilitet.
              </p>
              <ul className="text-xs text-slate-700 space-y-2 pt-2 border-t border-slate-200/60 font-medium">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                  <span>Hurtig dag-til-dag standardkørsel</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                  <span>Sammedagslevering (dag-til-i-dag)</span>
                </li>
              </ul>
            </div>

            {/* Box 3 */}
            <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200/80 space-y-4">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-sky-100 text-sky-700">
                <i className="fa-solid fa-stopwatch-20 text-xl" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-bold text-slate-900">
                Afgang inden for 2 timer
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Når maskiner står stille eller kritiske varer mangler, kan vi påbegynde kørslen på ruten inden for 2 timer efter aftale.
              </p>
              <ul className="text-xs text-slate-700 space-y-2 pt-2 border-t border-slate-200/60 font-medium">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                  <span>Kort responstid i hele regionen</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                  <span>Rettidighed og leveringsgaranti</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Scope and Capacity */}
          <div className="mt-16 p-8 rounded-2xl bg-slate-100 border border-slate-200 grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div>
              <span className="text-sky-700 font-bold text-xs uppercase tracking-wider block">Forsendelsesvægt</span>
              <span className="text-xl font-extrabold text-slate-900 mt-1 block">Fra 1 kg</span>
              <p className="text-xs text-slate-600 mt-0.5">Mindre pakker og hasteforsendelser</p>
            </div>
            <div>
              <span className="text-sky-700 font-bold text-xs uppercase tracking-wider block">Pallekapacitet</span>
              <span className="text-xl font-extrabold text-slate-900 mt-1 block">Op til 8 europaller</span>
              <p className="text-xs text-slate-600 mt-0.5">Samt ikke-standard gods efter aftale</p>
            </div>
            <div>
              <span className="text-sky-700 font-bold text-xs uppercase tracking-wider block">Dækning</span>
              <span className="text-xl font-extrabold text-slate-900 mt-1 block">Fuld godsforsikring</span>
              <p className="text-xs text-slate-600 mt-0.5">Varerne er dækket fra start til slut</p>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-20 bg-slate-50 border-t border-slate-200/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10 text-center max-w-2xl mx-auto space-y-2">
            <span className="text-xs font-bold uppercase tracking-wider text-sky-600">
              Vores beredskab
            </span>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
              Flåden bag vores eksprestjeneste
            </h2>
            <p className="text-slate-600 text-sm">
              Se billeder af vores driftssikre varevogne og kølebiler.
            </p>
          </div>

          <CMSGallery gallerySlug="transport4u" maxItems={6} />
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-16 bg-navy-950 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h2 className="text-2xl sm:text-3xl font-black text-white">
            Har du brug for akut ekspreskørsel?
          </h2>
          <p className="text-slate-300 text-base max-w-xl mx-auto">
            Udfyld vores bestillingsformular, send en e-mail til <a href="mailto:transport4u.dk@gmail.com" className="text-sky-400 hover:underline">transport4u.dk@gmail.com</a> eller ring på <a href="tel:+4550352035" className="text-sky-400 hover:underline">50 35 20 35</a>.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
            <Link
              to="/kontakt"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-xl bg-sky-500 hover:bg-sky-400 text-slate-950 font-bold text-sm transition-colors shadow-md whitespace-nowrap"
            >
              <span>Bestil online via formular</span>
              <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
            </Link>
            <a
              href="mailto:transport4u.dk@gmail.com"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-xl bg-slate-800 hover:bg-slate-700 text-white font-bold text-sm border border-slate-700 transition-colors whitespace-nowrap"
            >
              <i className="fa-solid fa-envelope text-sky-400" aria-hidden="true" />
              <span>Send e-mail</span>
            </a>
            <a
              href="tel:+4550352035"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-slate-900 hover:bg-slate-800 text-slate-300 hover:text-white text-xs font-semibold border border-slate-800 transition-colors whitespace-nowrap"
            >
              <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
              <span>Tlf: 50 35 20 35</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}
